<template>
    <section class="indian-card-games-banner live-casino-banner slot-games-banner">
        <div class="games-content-outer">
            <div class="container-fluid">
                <div class="slots-banner-outer">
                    <div class="banner-filtter-desktop">
                        <div class="Slots-header__filter">
                            <div class="Slots-header__filter-row">
                                <div class="slots-search-right">
                                    <input class="Slots-header__filter-row-search" type="text" placeholder="SEARCH GAMES" name="search" autocomplete="off" v-model="searchGameText">
                                    <img class="Slots-header__filter-row-icon" src="@/assets/images/searchIconDeskWhite.webp"
                                        alt="searchIconDeskWhite">
                                </div>
                            </div>
                        </div>
                        <div class="Slots-header__text">
                            <div class="Slots-header__text-name">SLOTS GAMES</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="banner-filtter-mobile">
        <div class="Slots-header__filter">
            <div class="Slots-header__filterMobile-search">
                <input class="Slots-header__filterMobile-search-input" type="text" name="search" autocomplete="off" placeholder="SEARCH GAMES" v-model="searchGameText">
                <img class="Slots-header__filterMobile-search-icon"
                    src="@/assets/images/searchIconDeskWhite.webp" alt="searchIconDeskWhite">
            </div>
        </div>
    </div>

    <section class="games-list-sec slots-games-list-sec" >
        <div class="cmn-casino-games-sec section-padding">
            <div class="container">
                <!-- <div class="games-sec-title">
                    <h2>{{ menu.title }}</h2>
                    <div class="see-all-link">
                        <a href="javascript:void(0);" @click="toggleSeeAll(menu)"> {{ menu.see_all ? 'See less' : 'See all'}}</a>
                    </div>
                </div> -->
                <div class="popular-games-list">

                    <div class="popular-game-item" v-for="(gameItem, mIndex) in filteredSlotGames" :key="mIndex">
                        <a href="javascript:void(0);" @click="clickOnGamestButton(gameItem)">
                            <figure>
                                <img :src="gameItem.image" :alt="gameItem.title" @error="setDefault($event)" loading="lazy" />.
                                <!-- <figcaption>{{ gameItem.game_name }}</figcaption> -->
                            </figure>
                        </a>
                    </div>
                    <div ref="addGamesToList"></div>

                </div>
            </div>
        </div>

    </section>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'SlotGames',
    data() {
        return {
            gamesList: null,
            selectedMenu: null,
            defaultGamePic: require('@/assets/images/casino-not-image-found-by-default-img.webp'),
            searchGameText: '',
            observer: null,
            currDisplayGames: 24
        }
    },
    mounted() {
        if(this.$auth?.user?.actw == 'WB') {
            this.$router.push({name: 'Home'});
            return;
        };
        this.setGamesList();
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.currDisplayGames += this.currDisplayGames
                }
            });
        });  
    },
    computed: {
        ...mapGetters(['gamesData']),
        filteredSlotGames() {
            if(this.searchGameText != '') {
                return this.gamesList.filter(gl => gl.game_name.toLowerCase().includes(this.searchGameText.toLowerCase()));
            };
            return this.gamesList?.slice(0, this.currDisplayGames);
        }
    },
    methods: {
        clickOnGamestButton(item) {
            if (this.$auth.status) {
                this.$loadCasinoGame.loadGame(item, this.$auth.user);
            }
            else {
                this.$helper.showLogin();
            }
        },
        setGamesList() {
            this.gamesList = this.gamesData[this.$route.name]?.games;
            setTimeout(() => {
                let targetElement = this.$refs.addGamesToList;
                if (targetElement) {
                    this.observer.observe(targetElement);
                }
            }, 1000);
        },
        scrollToElement(item) {;
            const [el] = this.$refs[Object.keys(this.$refs).filter(ref => ref == item.slug)];
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        },
        setDefault(e) {
            e.target.src = this.defaultGamePic
        },
    }
}

</script>

<style>

.popular-games-list {
    overflow-y: scroll !important;
}

.slot-games-banner {
    padding-bottom: 15px;
    margin-bottom: 5px;
}

</style>